import {AbstractControl, ValidatorFn} from '@angular/forms';
import _ from 'lodash';

/**
 * validator to check if control value is duplicated
 * @param options
 */
export function duplicatedValidator(options: string[], msg?: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && _.includes(options, control.value)) {
      return {duplicated: msg || true};
    }
    return null;
  };
}
